import React from 'react';

export type BannerProps = {
  className?: string;
  sender: string;
  content?: React.ReactNode;
};

const defaultBanner = (sender: string) => (
  <>This is a personal video message recorded for you by {sender}</>
);

const Banner = ({
  className = '',
  sender,
  content: defaultContent,
}: BannerProps) => {
  const content = defaultContent ? defaultContent : defaultBanner(sender);
  return (
    <div
      className={`text-xs bg-neutral-50 mb-4 text-neutral-600 h-10 flex items-center justify-center p-5 ${className}`}
    >
      <p className='m-0'>{content}</p>
    </div>
  );
};

export default Banner;
